import { Component, HostBinding, Input, ElementRef } from '@angular/core';
import { CarouselComponent } from './carousel.component';
var SlideComponent = (function () {
    function SlideComponent(carousel, el) {
        this.animated = false;
        this.directionNext = false;
        this.directionLeft = false;
        this.directionPrev = false;
        this.directionRight = false;
        this.el = null;
        this.carousel = carousel;
        this.el = el;
    }
    /** Fires changes in container collection after adding a new slide instance */
    SlideComponent.prototype.ngOnInit = function () {
        this.carousel.addSlide(this);
    };
    /** Fires changes in container collection after removing of this slide instance */
    SlideComponent.prototype.ngOnDestroy = function () {
        this.carousel.removeSlide(this);
    };
    return SlideComponent;
}());
export { SlideComponent };
SlideComponent.decorators = [
    { type: Component, args: [{
                selector: 'mdb-slide',
                template: "\n  <ng-content></ng-content>\n  "
            },] },
];
/** @nocollapse */
SlideComponent.ctorParameters = function () { return [
    { type: CarouselComponent, },
    { type: ElementRef, },
]; };
SlideComponent.propDecorators = {
    'active': [{ type: HostBinding, args: ['class.active',] }, { type: Input },],
    'animated': [{ type: HostBinding, args: ['class.animated',] },],
    'directionNext': [{ type: HostBinding, args: ['class.carousel-item-next',] },],
    'directionLeft': [{ type: HostBinding, args: ['class.carousel-item-left',] },],
    'directionPrev': [{ type: HostBinding, args: ['class.carousel-item-prev',] },],
    'directionRight': [{ type: HostBinding, args: ['class.carousel-item-right',] },],
    'carousel': [{ type: HostBinding, args: ['class.carousel-item',] },],
};
//# sourceMappingURL=slide.component.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular-bootstrap-md/carousel/slide.component.js
// module id = ../../../../angular-bootstrap-md/carousel/slide.component.js
// module chunks = 3